/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHardwareIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-hardware"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.82 21.8Q9.1 21.8 8.56 21.29Q8.03 20.77 8.03 20.05L8.03 13.3L15.38 13.3L15.38 20.05Q15.38 20.77 14.86 21.29Q14.35 21.8 13.63 21.8ZM8.03 10.65L8.03 8.55L4.38 8.55Q3.75 8.55 3.35 8.09Q2.95 7.63 3.08 7.03Q3.42 4.92 4.99 3.56Q6.55 2.2 8.68 2.2L13.63 2.2Q14.35 2.2 14.86 2.71Q15.38 3.23 15.38 3.95L15.38 5.35L17.93 2.8Q18.2 2.52 18.56 2.36Q18.93 2.2 19.32 2.2L19.85 2.2Q20.4 2.2 20.79 2.59Q21.18 2.98 21.18 3.52L21.18 9.78Q21.18 10.32 20.79 10.71Q20.4 11.1 19.85 11.1L19.32 11.1Q18.93 11.1 18.56 10.95Q18.2 10.8 17.93 10.53L15.38 7.95L15.38 10.65Z" fill={color} />
    </svg>
  );
}
